<script setup>
import { computed } from 'vue';
import { dasherize } from '../../../libs/strings';

const props = defineProps({
  modelValue: { type: String, required: false, default: null },
  checkedValue: { type: String, required: true },
  uncheckedValue: { type: String, required: false, default: null },
  icon: { type: String, required: true },
  iconType: { type: String, required: false, default: 'far' },
  activeClass: { type: String, required: false, default: 'text-success' },
});

const emit = defineEmits(['update:modelValue']);

const active = computed(() => props.modelValue === props.checkedValue);

function toggle() {
  if (!active.value) {
    emit('update:modelValue', props.checkedValue);
  } else {
    emit('update:modelValue', props.uncheckedValue);
  }
}
</script>

<template>
  <i
    :class="`fa ${iconType} fa-${dasherize(icon)} ${active ? 'active ' + activeClass : ''}`"
    @click="toggle"
  >
  </i>
</template>

<style lang="scss" scoped>
@import "../../../../assets/stylesheets/cifra/vars/main.scss";

i {
  cursor: pointer;
}

i:not(.active):before {
  color: $gris-disabled;
}
</style>
